import { AssigneeTypeEnum } from '@omnea-app/packages/universal/users-and-groups/assigneeType'
import type { VariableAssigneeEntity } from '@omnea-app/packages/universal/workflow/assigneeEntity'

export const REQUESTOR_ID = 'requestor'

export const ASSESSMENT_OWNER_ID = 'businessOwner'

export const requestorAssignee = {
  value: 'Requestor',
  id: REQUESTOR_ID,
  type: AssigneeTypeEnum.VARIABLE,
  name: 'Requestor',
}

export const assessmentOwnerAssignee = {
  value: 'Business Owner',
  id: ASSESSMENT_OWNER_ID,
  type: AssigneeTypeEnum.VARIABLE,
  name: 'Business Owner',
}

// Agreement roles: the renewals service resolves these from the agreement, not from form answers like the ones above.
export const agreementBusinessOwnersAssignee: VariableAssigneeEntity = {
  value: 'Business owners',
  id: 'agreementBusinessOwners',
  type: AssigneeTypeEnum.VARIABLE,
  name: 'Business owners',
}

export const agreementProcurementOwnerAssignee: VariableAssigneeEntity = {
  value: 'Procurement owner',
  id: 'agreementProcurementOwner',
  type: AssigneeTypeEnum.VARIABLE,
  name: 'Procurement owner',
}
